"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../context/MessageContext"));
var _updateGuestState = _interopRequireWildcard(require("../../utils/cart/updateGuestState"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Register = _interopRequireDefault(require("./Register.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Register = _ref => {
  var _systemLink;
  let {
    lang
  } = _ref;
  const {
    cart,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const navigate = (0, _useLink.default)();
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _Register.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const registerUrl = (_systemLink = systemLink("shop-registration")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  const handleGuestLogin = async () => {
    const response = await (0, _updateGuestState.default)(true);
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_updateGuestState.UPDATE_GUEST_STATE_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    navigate("/".concat(lang, "/shop/checkout/addresses/guest/new"));
  };
  const handleRegistration = () => {
    navigate(registerUrl);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.register, "mco-shop-register")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.headline,
    component: "h2"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.register.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.text
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.register.text",
    l: l
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: css.buttons
  }, !(0, _isEmpty.default)(cart) && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: css.button,
    color: "primary",
    fullWidth: true,
    variant: "outlined",
    onClick: handleGuestLogin
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.register.buttons.guestLogin",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: css.button,
    color: "primary",
    fullWidth: true,
    variant: "outlined",
    onClick: handleRegistration
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.register.buttons.register",
    l: l
  }))));
};
var _default = exports.default = Register;